// extracted by mini-css-extract-plugin
export var Profile = "socials-module--Profile--KssZf";
export var Delegation = "socials-module--Delegation--3Bs2A";
export var DelegationContainer = "socials-module--Delegation-container--ZbRQ4";
export var delegationH3 = "socials-module--delegation-h3--AbW2+";